import { getImprintData } from '@/actions/legalPlages'
import { focusIds } from '@/constants/focus'
import { settingsTitles } from '@/constants/settings'

import { StaticHTMLPage } from './StaticHTMLPage'

const focusId = `${focusIds.SETTINGS_IMPRINT}${focusIds.CONTAINER_MOD}`

export const Imprint = () => (
  <StaticHTMLPage
    titleTranslationKey={settingsTitles.IMPRINT}
    onPageLoad={getImprintData}
    focusId={focusId}
  />
)
